import { Alert, Box, Button, Divider, FormControl, InputLabel, MenuItem, Paper, Select, TextField, Typography } from '@mui/material';
import { Kitchen } from '@mui/icons-material';
import { useCadastrarEditarProdutoContext } from '../../contexts/CadastrarEditarProdutoContext';
import { useEstacoesKDS } from '../../../cozinha/hooks/useEstacoesKDS';
import { ProcessoPreparoForm } from '../../../cozinha/components/ProcessoPreparoForm';

export const ConfiguracaoKDSContainer = () => {
    const {
        configuracaoKDS,
        setConfiguracaoKDS,
        handleVoltar,
        handleProximo,
        processosPreparoKDS,
        adicionarProcessoKDS,
        editarProcessoKDS,
        removerProcessoKDS,
        kdsDesabilitado,
        kdsSimples,
    } = useCadastrarEditarProdutoContext();

    const { estacoes } = useEstacoesKDS();

    if (kdsDesabilitado) {
        return (
            <Paper sx={{ width: '100%', p: 2, display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <Kitchen color="disabled" />
                    <Typography variant="h6">Integração KDS</Typography>
                </Box>
                <Alert severity="info" sx={{ mb: 3 }}>
                    O KDS está desabilitado. Configure o modo em Cozinha &gt; Configurações.
                </Alert>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <Button variant="outlined" size="medium" onClick={handleVoltar}>Voltar</Button>
                    <Button variant="contained" size="medium" onClick={handleProximo}>Próximo</Button>
                </Box>
            </Paper>
        );
    }

    if (kdsSimples) {
        return (
            <Paper sx={{ width: '100%', p: 2, display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <Kitchen color="disabled" />
                    <Typography variant="h6">Integração KDS</Typography>
                </Box>
                <Alert severity="info" sx={{ mb: 3 }}>
                    No modo KDS Simples, o roteamento é configurado por estação. Não é necessário configurar KDS por produto.
                </Alert>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <Button variant="outlined" size="medium" onClick={handleVoltar}>Voltar</Button>
                    <Button variant="contained" size="medium" onClick={handleProximo}>Próximo</Button>
                </Box>
            </Paper>
        );
    }

    const estacaoKdsUuid = configuracaoKDS?.estacaoKdsUuid ?? '';
    const tempoMinutos = configuracaoKDS?.tempoPreparoSegundos
        ? Math.round(configuracaoKDS.tempoPreparoSegundos / 60)
        : 5;

    const handleEstacao = (uuid: string) => {
        if (!uuid) {
            setConfiguracaoKDS(undefined);
            return;
        }
        setConfiguracaoKDS({ estacaoKdsUuid: uuid, tempoPreparoSegundos: tempoMinutos * 60 });
    };

    const handleTempo = (minutos: number) => {
        if (!estacaoKdsUuid) return;
        setConfiguracaoKDS({ estacaoKdsUuid, tempoPreparoSegundos: minutos * 60 });
    };

    return (
        <Paper sx={{ width: '100%', p: 2, display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Kitchen color={estacaoKdsUuid || processosPreparoKDS.length > 0 ? 'primary' : 'disabled'} />
                <Typography variant="h6">Integração KDS</Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Configure como este produto é processado na cozinha. Use a estação padrão para produtos simples,
                ou defina processos de preparo para fluxos com múltiplas etapas.
            </Typography>

            <Typography variant="subtitle2" fontWeight="bold" color="text.secondary" sx={{ mb: 1 }}>
                ESTAÇÃO PADRÃO
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 1.5, display: 'block' }}>
                Usada quando não há processos de preparo configurados abaixo.
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
                <FormControl size="small" fullWidth>
                    <InputLabel>Estação KDS</InputLabel>
                    <Select
                        value={estacaoKdsUuid}
                        label="Estação KDS"
                        onChange={(e) => handleEstacao(e.target.value)}
                    >
                        <MenuItem value=""><em>Nenhuma</em></MenuItem>
                        {estacoes.map((e) => (
                            <MenuItem key={e.uuid} value={e.uuid}>{e.nome}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {estacaoKdsUuid && (
                    <TextField
                        label="Tempo de preparo (min)"
                        type="number"
                        size="small"
                        value={tempoMinutos}
                        onChange={(e) => handleTempo(Math.max(1, Number(e.target.value)))}
                        inputProps={{ min: 1, max: 120 }}
                        fullWidth
                    />
                )}
            </Box>

            <Divider sx={{ my: 3 }} />

            <ProcessoPreparoForm
                processos={processosPreparoKDS}
                estacoes={estacoes}
                onAdicionar={async (dados) => adicionarProcessoKDS(dados)}
                onAtualizar={async (uuid, dados) => editarProcessoKDS(uuid, dados)}
                onRemover={async (uuid) => removerProcessoKDS(uuid)}
            />

            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Button variant="outlined" size="medium" onClick={handleVoltar}>Voltar</Button>
                <Button variant="contained" size="medium" onClick={handleProximo}>Próximo</Button>
            </Box>
        </Paper>
    );
};
